module.exports = __webpack_public_path__ + "static/img/app2.d3844c25.png";